import { withSignInEnhancerProps } from 'viewModel/enhancedMarkdown/addSignInEnhancer/withSignInEnhancerProps';
import AddSignInEnhancer from 'components/EnhancedMarkdown/AddSignInEnhancer/AddSignInEnhancer';

export default withSignInEnhancerProps(AddSignInEnhancer);
